import { ImportDelegationsCtx } from "../ImportDelegationsContext";
import { useContext } from "react";

const useImportDelegationsContext = () => useContext(ImportDelegationsCtx);

export default useImportDelegationsContext;
